import { EMAIL_LIST_TYPE } from '../../../../constants/email-variables.constants';
import { withViewModel } from '../../../../infrastructure/components/with-view-model';
import { EmailVariablesFormPresentation } from './email-variables-form.presentation';
import { EmailVariablesFormVM } from './email-variables-form.viewmodel';

interface IProps {
    type: EMAIL_LIST_TYPE;
}

export const EmailVariablesForm = withViewModel(EmailVariablesFormPresentation, async (props: IProps) => {
    const vm = new EmailVariablesFormVM(props.type);

    await vm.initialize();

    return vm;
});
